import Pagination from './Pagination';
export default Pagination;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/pagination/index.js
// module id = null
// module chunks = 